module.exports = "/_next/static/images/group-4-12055c0b.png";